// eslint-disable-next-line import/no-extraneous-dependencies
import { GrowthBook } from '@growthbook/growthbook';
import { trackEvent } from '@/features/common/helpers/google-analytics';

const getFeaturesJson = (featuresEndpoint) => {
  return fetch(featuresEndpoint)
    .then((response) => {
      return response.json();
    });
};

export const GrowthBookVuePlugin = {
  install: (Vue, { featuresEndpoint, enableDevMode = false }) => {
    let growthBook = null;
    let initPromise = null;

    // eslint-disable-next-line no-param-reassign
    Vue.prototype.initGrowthBook = function initGrowthBook() {
      if (growthBook) {
        return Promise.resolve(growthBook);
      }

      if (initPromise) {
        return initPromise;
      }

      initPromise = getFeaturesJson(featuresEndpoint)
        .then((json) => {
          growthBook = new GrowthBook({
            enableDevMode,
            trackingCallback: (experiment, result) => {
              trackEvent(this.$gtag, 'experiment_viewed', {
                experimentId: experiment.key,
                variationId: result.key,
              });
            },
          });

          growthBook.setFeatures(json.features);
          return growthBook;
        })
        .catch(() => {
          return null;
        })
        .finally(() => {
          initPromise = null;
        });

      return initPromise;
    };
  },
};
